import { pairOf } from './task-currency';
import type { DisplayRate } from './rate-mapping';

/**
 * TEKLIF KURU <-> TCMB REFERANSI SAPMA UYARISI.
 *
 * Buro teklifini onaylamadan once, girdigi kur o ciftin TCMB referansindan belirgin bicimde
 * uzaksa bir UYARI gorur. ENGELLEMEZ: buro kurunu kendisi belirler, TCMB bulteni gunde bir
 * kez yayinlaniyor ve piyasa gun icinde oynuyor. Amac yazim hatasini (34,56 yerine 3,456 ya
 * da 345,6) onay ekraninda yakalamak.
 *
 * ESIK BIR URUN KARARIDIR: %5 (2026-09-23, onaylandi). Degisirse yalniz bu sabit degisir;
 * mobil `src/shared/utils/rateDeviation.ts` ile ayni deger.
 */
export const OFFER_RATE_DEVIATION_WARN = 0.05;

/**
 * Teklif kurunun TCMB referansi: 1 birim `currency`nin `secondCurrency` cinsinden fiyati.
 * Bulunamazsa `null` — uyari gosterilmez.
 *
 * TRY karsilikli ciftlerde referans alis/satisin ORTASI: teklif, musterinin alis ya da
 * satisina gore yazilsa da ayni banda duser ve orta nokta iki yone de tarafsiz.
 *
 * EUR/USD bultende yok, EUR satirinin capraz kurundan TURETILIYOR (rate-mapping.ts). Teklif
 * YONDEN BAGIMSIZ olarak 1 EUR'nun USD karsiligi yazilir (2026-09-23, bkz. task-currency.ts),
 * dolayisiyla referans her iki yonde de capraz kurun kendisi.
 */
export const referenceRateFor = (
  rates: readonly DisplayRate[],
  taskTypeCode: string,
): number | null => {
  const pair = pairOf(taskTypeCode);
  const row = rates.find((item) => item.taskTypeCode === taskTypeCode);
  if (!row) return null;
  if (pair.currency !== row.baseCurrency || pair.secondCurrency !== row.quoteCurrency) return null;
  // Turetilmis satirda (EUR/USD) alis = satis = capraz kur; digerlerinde bant ortasi.
  const reference = row.derived ? row.buy : (row.buy + row.sell) / 2;
  return Number.isFinite(reference) && reference > 0 ? reference : null;
};

/** Goreli sapma |teklif - referans| / referans. Referans yoksa `null`. */
export const rateDeviation = (offerRate: number, reference: number | null): number | null => {
  if (reference === null || !(reference > 0) || !Number.isFinite(offerRate)) return null;
  return Math.abs(offerRate - reference) / reference;
};

/** Esik ASILDI mi? Esik degerinin kendisi uyari uretmez. Referans yoksa uyari yok. */
export const exceedsDeviation = (
  offerRate: number,
  reference: number | null,
  threshold: number = OFFER_RATE_DEVIATION_WARN,
): boolean => {
  const deviation = rateDeviation(offerRate, reference);
  return deviation !== null && deviation > threshold;
};
